{
  "title": "Imports",
  "dropzone": {
    "title": "Drop a PDF or image here",
    "hint": "or click to choose a file",
    "unsupported": "Unsupported file type. Use PDF, PNG or JPEG.",
    "tooManyPages": "This document has too many pages to load.",
    "pageTooLarge": "One of the pages is too large to process.",
    "fileTooLarge": "This file is too large.",
    "noFileReceived": "No file was received. Try again, or drag the file onto this box.",
    "accepted": "Accepted formats: PDF, PNG, JPEG",
    "prepareFailed": "Some pages could not be prepared. See the list below.",
    "converting": "Preparing pages..."
  },
  "extract": {
    "button": "Extract text",
    "cancel": "Cancel",
    "progress": "Extracting page {{current}} of {{total}}...",
    "serviceNotReady": "The extraction service is not available right now.",
    "noOcrLines": "No text was found on this page.",
    "ocrProgress": "Reading text on page {{current}} of {{total}}...",
    "clear": "Clear",
    "cancelled": "Cancelled. Completed pages are kept.",
    "cancelling": "Cancelling...",
    "retryHint": "Press Extract again to retry only the failed pages.",
    "partialFailure": "Some pages could not be processed. See the list below.",
    "noSelection": "Select the pages you want to extract.",
    "reviewLabel": "Review handwriting and amendments (uses page images)",
    "reviewHint": "Slower. Changes are only suggested, never applied automatically.",
    "reviewProgress": "Reviewing amendments on page {{current}} of {{total}}...",
    "retryReview": "Retry review ({{count}})",
    "scanTablesLabel": "Scan tables (structured layouts such as closing disclosures)",
    "scanTablesHint": "Slower and more costly per page. Pages already extracted are not re-read.",
    "keptEdits": "{{count}} edited value(s) were kept instead of being replaced by the new extraction."
  },
  "editor": {
    "title": "Markdown editor",
    "placeholder": "Extracted text will appear here...",
    "lines": "Lines",
    "noLines": "No lines yet.",
    "source": "Page {{page}}, line {{line}}",
    "lineNo": "Line {{line}}",
    "advanced": "Markdown for the assistant",
    "advancedHint": "Read-only. Edit values in the list; this is what the assistant receives."
  },
  "badge": {
    "unknown-key": "Unknown key",
    "manual": "Manual",
    "malformed": "Malformed",
    "phase-2": "Phase 2",
    "unverified": "Unverified"
  },
  "viewer": {
    "title": "Source",
    "zoom": "Zoom",
    "noSource": "No source location",
    "noPages": "No pages to show.",
    "page": "Page {{page}}",
    "pageOf": "Page {{page}} of {{total}}",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "selectPage": "Select page",
    "boxLabel": "Line: {{text}}",
    "enlarge": "Enlarge page",
    "close": "Close",
    "previewTitle": "{{file}} - page {{page}}",
    "unusedBox": "No data line uses this text."
  },
  "target": {
    "title": "Target",
    "new": "New",
    "existing": "Existing",
    "transactionType": "Transaction type",
    "type": "Type",
    "workflow": "Workflow",
    "agency": "Agency",
    "searchOrder": "Search order",
    "incomplete": "Complete the target fields before sending.",
    "searchHint": "Type at least 2 characters to search orders.",
    "searching": "Searching orders...",
    "noResults": "No orders found.",
    "searchError": "Orders could not be searched. Try again."
  },
  "handoff": {
    "button": "Send to Assistant",
    "note": "The assistant will receive the extracted text and the selected target.",
    "confirmation": "Sent to the assistant.",
    "notReady": "Extract text and select a target before sending."
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "ocrFailed": "Text recognition failed for this page.",
    "extractFailed": "The document could not be extracted."
  },
  "pages": {
    "title": "Pages",
    "empty": "No pages yet.",
    "pending": "Pending",
    "done": "Done",
    "error": "Error",
    "skipped": "Skipped",
    "cancelled": "Cancelled",
    "extracted": "Extracted",
    "lineCount": "{{total}} lines",
    "thumbnailAlt": "{{file}}, page {{page}}",
    "preview": "Preview {{file}}, page {{page}}",
    "openPreview": "Open full preview of {{file}}, page {{page}}",
    "select": "Select {{file}}, page {{page}} for extraction",
    "selectedCount": "{{selected}} of {{max}} pages selected",
    "clearSelection": "Clear selection",
    "limitReached": "You can select up to {{max}} pages at a time. Extract them or deselect one to choose others."
  },
  "issues": {
    "ocrError": "Text recognition failed",
    "extractError": "Extraction failed",
    "noLines": "No text found",
    "reviewError": "Amendment review failed",
    "tableCheck": "Table totals or layout need review"
  },
  "amendments": {
    "title": "Amendments to review",
    "hint": "Handwritten or corrected values found on the page. Accept to update the data, or dismiss.",
    "current": "Current",
    "suggested": "Suggested",
    "accept": "Accept",
    "dismiss": "Dismiss",
    "line": "line {{line}}",
    "noSource": "No source line",
    "confirmAmountTitle": "Confirm amount change",
    "confirmAmountReplace": "Change {{key}} from {{current}} to {{suggested}}?",
    "confirmAmountAdd": "Add {{key}} with {{suggested}}? This page has no current value for it.",
    "confirm": "Confirm",
    "announce": "Suggested amendments to review: {{count}}"
  },
  "groups": {
    "order": "Order",
    "party": "Parties",
    "property": "Property",
    "loan": "Loan",
    "charge": "Charges",
    "amount": "Amounts",
    "note": "Notes",
    "other": "Other"
  },
  "rows": {
    "summary": "{{lines}} lines · {{flagged}} need review",
    "nextFlagged": "Next flagged",
    "valueFor": "Value for {{key}}",
    "edited": "Edited",
    "showSource": "Show source on page",
    "noSource": "No source on this line",
    "showSourceFor": "Show source for {{key}}",
    "originalValue": "Original: {{value}}",
    "resetFor": "Reset {{key}} to the original value",
    "removeFor": "Remove {{key}}",
    "removed": "Removed",
    "showOnlyFor": "Show only {{key}}",
    "restore": "Restore"
  },
  "links": {
    "announce": "{{key}}, page {{page}}, line {{line}} selected"
  },
  "tabs": {
    "label": "Views",
    "list": "List",
    "markdown": "Markdown",
    "restore": "Restore"
  },
  "send": {
    "clearTitle": "Clear the current conversation?",
    "clearBody": "The assistant already has a conversation open. Sending this import clears it first, so the new import starts with a clean history.",
    "clearConfirm": "Clear and send",
    "busy": "The assistant is still answering. Wait for it to finish, then send."
  },
  "filter": {
    "label": "Filter",
    "placeholder": "Filter by key, label or value",
    "empty": "No rows match the filter.",
    "clear": "Clear filter"
  },
  "steps": {
    "label": "Import steps",
    "document": "Document",
    "review": "Review",
    "send": "Send",
    "back": "Back",
    "next": "Next",
    "close": "Close"
  }
}
